<template>
  <div>
    <div class="page-title">{{title}}<span v-if="titleNum !== ''">（{{titleNum}}）</span></div>
    <!-- 流量结算-调研流水报告查询单独配置 -->
    <pageTab
      v-if="routerName === 'reportSearch' || routerName === 'reportTerminal'"
      :paramsLabel="'type'"
      :isParams="false"
      :nowTab="routerName"
      :tabs="tab"
    ></pageTab>
    <page-search
      :layout="searchLayout"
      @search="search"
      @exportTable="exportTable"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageIndex="page"
      @compFn="compFn"
      :pageSize="pageSize"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
    <bank-file-diag
      :noData="!isVerificationCode"
      :isShow="receiptDiaShow"
      :curId="curId"
      :curCode="curCode"
      :curUrl="curUrl"
      :loading="receiptLoading"
      @close="dialogClose"
    ></bank-file-diag>
  </div>
</template>

<script>
import Vue from 'vue'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import bankFileDiag from './bankFileDiag'
import pageTab from '@/components/pageCom/pageTab.vue'

import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import tradeDataMixin from './tradeDataMixin'

import { getFlow, getReceiptDownload, getFlowNew } from '@/api/trade'
import { downFile } from '@/utils/file'
import { formatText } from '@/utils/common'

export default {
  name: 'trade',
  components: {
    bankFileDiag,
    pageSearch, pageTable,
    pageTab
  },
  mixins: [pageTableMixin, tradeDataMixin],
  data() {
    return {
      receiptLoading: false,
      receiptDiaShow: false,
      isVerificationCode: true, // 回单弹窗是否有数据
      title: '',
      titleNum: '',
      col: [],
      searchLayout: [],
      exportUrl: '',
      receiptType: '', // 回单下载的type
      queryNo: '', // 搜索的企业编码
      queryName: '', // 搜索的企业名称
      queryTime: [], // 时间
      queryPayer: '', // 搜索的付款方
      queryPayee: '', // 搜索的收款方
      queryType: '', // 账户互转流水查询 转账方式
      t_agent_info_agent_name: '', // 渠道
      t_agent_info_agent_name_shoukuanfang: '', // 收款方
      t_agent_info_agent_name_fukuanfang: '', // 付款方
      curId: '',
      curCode: '',
      curUrl: '',
      queryPayType: '', // 调研报告流水-支付方式
      // 流量查询-调研流水报告查询tab
      tab: [
        { linkName: 'reportSearch', text: '品类调研报告' },
        { linkName: 'reportTerminal', text: '终端调研报告' }
      ]
    }
  },
  computed: {
    // 路由名称
    routerName() {
      return this.$route.name
    }
  },
  watch: {
    // 监听路由变化，清空筛条件
    $route() {
      this.clearSearchData()
    }
  },
  methods: {
    compFn(params) {
      if (params.type === 'receipt') {
        this.receipt(params.data)
      } else if (params.type === 'checkVip') {
        this.checkVip(params.data)
      }
    },
    // 回单
    receipt(item) {
      this.receiptDiaShow = true
      this.receiptLoading = true
      getReceiptDownload({
        statement_num: this.receiptType === '3' || this.receiptType === '4' ? item.account_num : item.statement_num,
        type: this.receiptType,
        cust_no: this.receiptType === '3' || this.receiptType === '4' ? item.cust_no : ''
      }).then(res => {
        this.receiptLoading = false
        this.isVerificationCode = false
        if (res.code === 0) {
          this.isVerificationCode = true
          this.curId = res.result.huidanhao
          this.curCode = res.result.yanzheng_ma
          this.curUrl = res.result.receipt_url
        }
      })
    },
    // 会员线下审核
    checkVip(item) {
      this.$router.push({ path: '/trade-detail/check-vip/' + item.check_status + '/' + item.order_no })
    },
    // 搜索
    search(query) {
      this.queryNo = query.code || ''
      this.queryName = query.name || ''
      this.queryTime = query.date || []
      this.queryPayer = query.payer || ''
      this.queryPayee = query.payee || ''
      this.queryType = query.type || ''
      this.t_agent_info_agent_name = query.t_agent_info_agent_name || ''
      this.t_agent_info_agent_name_shoukuanfang = query.t_agent_info_agent_name_shoukuanfang || ''
      this.t_agent_info_agent_name_fukuanfang = query.t_agent_info_agent_name_fukuanfang || ''
      this.queryPayType = query.payType === '-1' && query.payType !== '' && query.payType !== null && query.payType !== undefined ? '' : query.payType
      this.initTable()
      this.getData()
    },
    exportTable() {
      const query = this.formQuery()
      query.table_type = this.exportUrl
      const url = process.env.VUE_APP_BASE_API + '/business/export_excel'
      downFile(url, query)
    },
    getData(getType = '') {
      if (getType) {
        this.clearSearchData()
      }
      const query = this.formQuery()
      this.tableLoading = true
      const obj = {
        aliPayment: 'member_alipay',
        vipPayment: 'member_transfer_verify',
        ukeyPayment: 'ukey',
        tranService: 'service',
        recharge: 'recharge',
        withdrawal: 'withdrawal',
        payment: 'pay',
        receivable: 'collection',
        sameTradeDetail: 'bank_same_water',
        reportSearch: 'diaoyanbaogao_liushui',
        receivableAccount: 'collection2020' // 对账中心-收款流水单号
      }
      const type = this.$route.name === 'reportTerminal' ? 'reportSearch' : this.$route.name
      // 获取列表数据
      getFlow({
        name: obj[type],
        data: query
      }).then(res => {
        this.tableLoading = false
        if (res.code !== 0) {
          return
        }
        if (res.result === undefined || res.result === null || !Array.isArray(res.result.data)) {
          this.tableData = []
          this.titleNum = 0
          this.total = 0
        } else {
          this.tableData = res.result.data
          this.titleNum = res.result.total
          this.total = res.result.total
        }
        if (this.$route.name === 'vipPayment') {
          this.initVipCount()
        //   let count = res.result.total
        //   if (Number(count) > 99) {
        //     count = '...'
        //   }
        //   this.$store.commit('SET_VIP_COUNT', count)
        }
      })
    },
    initVipCount() {
      getFlowNew({
        name: 'member_need_check_count',
        data: {}
      }).then(res => {
        let count = (res.result && res.result.count) || 0
        if (Number(count) > 99) {
          count = '...'
        }
        this.$store.commit('SET_VIP_COUNT', count)
      })
    },
    formQuery() { // f formQuery是拿当前页面展示的数据的值
      let query = {
        per_page: this.pageSize,
        page: this.page
      }
      query = this.addQuery(query, 'cust_no', this.queryNo)
      query = this.addQuery(query, 'cust_name', this.queryName)
      query = this.addQuery(query, 'payer', this.queryPayer)
      query = this.addQuery(query, 'receiver', this.queryPayee)
      query = this.addQuery(query, 'type', this.queryType)
      query = this.addQuery(query, 'pay_type', this.queryPayType)
      query = this.addQuery(query, 't_agent_info_agent_name', this.t_agent_info_agent_name)
      query = this.addQuery(query, 't_agent_info_agent_name_shoukuanfang', this.t_agent_info_agent_name_shoukuanfang)
      query = this.addQuery(query, 't_agent_info_agent_name_fukuanfang', this.t_agent_info_agent_name_fukuanfang)
      if (this.queryTime.length) {
        if (this.$route.name === 'aliPayment' || this.$route.name === 'vipPayment') {
          query = this.addQuery(query, 'order_start_time', this.queryTime[0])
          query = this.addQuery(query, 'order_end_time', this.queryTime[1])
        } else if (this.$route.name === 'recharge') {
          query = this.addQuery(query, 'recharge_date', this.queryTime)
        } else if (this.$route.name === 'withdrawal') {
          query = this.addQuery(query, 'withdraw_date', this.queryTime)
        } else if (this.$route.name === 'payment' || this.$route.name === 'receivable' || this.$route.name === 'sameTradeDetail' || this.$route.name === 'receivableAccount') {
          query = this.addQuery(query, 'payment_date', this.queryTime)
        } else if (this.$route.name === 'ukeyPayment' || this.$route.name === 'tranService') {
          query = this.addQuery(query, 'create_time', this.queryTime)
        } else if (this.$route.name === 'reportSearch' || this.$route.name === 'reportTerminal') {
          query = this.addQuery(query, 'start_time', this.queryTime[0])
          query = this.addQuery(query, 'end_time', this.queryTime[1])
        }
      }
      if (this.$route.name === 'reportSearch' || this.$route.name === 'reportTerminal') {
        const type = this.$route.name === 'reportSearch' ? 'pinlei' : 'zhongduan'
        query = this.addQuery(query, 'baogao_type', type)
      }
      return query
    },
    dialogClose() {
      this.receiptDiaShow = false
      this.curId = ''
      this.curCode = ''
      this.curUrl = ''
      this.isVerificationCode = true
    },
    // 清空筛选条件
    clearSearchData() {
      this.queryNo = ''
      this.queryName = ''
      this.queryPayer = ''
      this.queryPayee = ''
      this.queryType = ''
      this.queryPayType = ''
      this.t_agent_info_agent_name = ''
      this.t_agent_info_agent_name_fukuanfang = ''
      this.t_agent_info_agent_name_shoukuanfang = ''
      this.queryTime = []
    }
  }
}

Vue.component('operateTrad', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    receipt() {
      this.$emit('on-custom-comp', { type: 'receipt', data: this.rowData })
    },
    checkVip() {
      this.$emit('on-custom-comp', { type: 'checkVip', data: this.rowData })
    }
  },
  render: function(h) {
    if (this.$route.name === 'vipPayment') {
      const ope = formatText(this.rowData.check_status, ['审核', '查看'])
      return h('div', {
        class: {
          operate: true
        }
      }, [h('a', {
        on: {
          click: this.checkVip
        }
      }, ope)])
    } else {
      const ope = this.$route.name === 'payment' && this.rowData.type === '9' ? '' : '回单下载'
      return h('div', {
        class: {
          operate: true
        }
      }, [h('a', {
        on: {
          click: this.receipt
        }
      }, ope)])
    }
  }
})
</script>

<style lang="scss">
  .vertical-center-modal .ivu-modal-close .ivu-icon-ios-close {
    background: url('../../assets/icon.svg') no-repeat -354px -134px;
  }
</style>
